import './style.scss';

export function spacer_block() {
    const selector = document.querySelector('.spacer_block');
    if (!selector) return;

}
